const stepperCards = [
  {
    order: 1,
    name: 'idea',
    detail:
      'We begin by meeting with your team to determine your key requirements and specifications. Through in-depth discussion, we gain a better understanding of your business goals.',
    active: false
  },
  {
    order: 2,
    name: 'Business Analysis',
    detail:
      'In cooperation with you, we create optimal workflow plan based on your inquiries. We determine the appropriate software and frameworks to provide a scalable solution.',
    active: true
  },
  {
    order: 3,
    name: 'Design',
    detail:
      'A great design, combined with useful features, leads to a successful product. We give you ideas for an accessible and intuitive user interface options.',
    active: false
  },
  {
    order: 4,
    name: 'Development',
    detail:
      'Our goal is to be your long-term partner, not just another vendor. We strive to build software that withstands the test of time and truly transforms your business. With an iterative development process, we offer software solutions that evolve through collaboration to meet your needs.',
    active: false
  },
  {
    order: 5,
    name: 'Testing',
    detail:
      'Software testing is a crucial part of our development process. We employ both, manual and automated testing methods to ensure your application and system functionality operate as designed.',
    active: false
  },
  {
    order: 6,
    name: 'Deployment',
    detail:
      'Once your software has been developed and tested, the final step is deployment. No matter which deployment model you choose, our team can make the process seamless, so you can focus on growing your business.',
    active: false
  },
  {
    order: 7,
    name: 'Maintenance and Support',
    detail:
      'As your business grows, your software needs to scale with it. Our engineers can optimize software performance and make necessary upgrades to support your expansion.',
    active: false
  }
]

export default stepperCards
